import React from 'react'
import type { Icon } from 'shared/utils'

const CashRegister = (props: Icon) => {
    const { color = 'black', size = 24, className = 'drive' } = props
    return (
        <svg
            className={className}
            width={size}
            height={size}
            fill={color}
            viewBox="0 0 24 24"
            preserveAspectRatio="none">
            <path d="M3.095 16.19h17.81c.447 0 .81.342.81.762V20c0 1.262-1.088 2.286-2.43 2.286H4.716c-1.342 0-2.43-1.024-2.43-2.286v-3.048c0-.42.363-.762.81-.762zM10.381 20h3.238c.447 0 .81-.341.81-.762 0-.42-.363-.762-.81-.762h-3.238c-.447 0-.81.341-.81.762 0 .42.363.762.81.762zm10.755-4.556a1.733 1.733 0 0 0-.231-.015H3.095c-.078 0-.155.005-.23.015l2.31-5.436c.368-.868 1.261-1.437 2.254-1.437h9.142c.993 0 1.886.57 2.254 1.437l2.31 5.436zM7.952 12.38h4.858c.447 0 .809-.341.809-.762 0-.42-.362-.762-.81-.762H7.953c-.447 0-.81.341-.81.762 0 .42.363.762.81.762zm7.286 0h.81c.447 0 .81-.341.81-.762 0-.42-.363-.762-.81-.762h-.81c-.447 0-.81.341-.81.762 0 .42.363.762.81.762z" />
            <path d="M12.81 9.333h-1.62v-3.81h1.62z" />
            <path d="M8.762 1.714h6.476c.894 0 1.62.683 1.62 1.524v1.524c0 .841-.726 1.524-1.62 1.524H8.762c-.894 0-1.62-.683-1.62-1.524V3.238c0-.841.726-1.524 1.62-1.524z" />
        </svg>
    )
}

export { CashRegister }
